import { isSkipCaptcha, toExcludeAttribute, WORKFLOW } from '../vs-standard-form.constant';
import { parseDateValue } from './date.helper';
import { loginEndPoint } from '@src/workflows/vs-standard-form/vs-standard-form.constant';
import { FormError, FormInfoData } from '../vs-standard-form.model';

export const getNonVSFUFileSubmissionPayLoad = (formData: FormInfoData,
                                                promoId: string,
                                                fileContent: any,
                                                vcesCardNumber: string = null,
                                                urlToken: string = null) => {
  const dataJson = JSON.stringify(
    getFormPayload(formData, promoId, vcesCardNumber, null, urlToken));
  const result = new FormData();
  result.append('file', fileContent);
  result.append('data', dataJson);
  return result;
};

export const getSubmissionPayload = (formData: FormInfoData,
                                     promoId: string,
                                     urlToken: string,
                                     workflow: string,
                                     vsfuScanId: string = null,
                                     vcesCardNumber: string = null) => {
  if (workflow?.toLowerCase() === WORKFLOW.UNENROLL_VOP) {
    const emailFormFieldValue = formData?.detail?.email?.value;
    if (emailFormFieldValue) {
      return {
        ...getUnEnrollFormPayload(emailFormFieldValue, promoId, urlToken),
        ...extractKeyValueFromObject(getHCaptchaPayload(formData)),
      };
    } else {
      return null;
    }
  } else {
    return getFormPayload(formData, promoId, vsfuScanId, vcesCardNumber,  urlToken);
  }
};

export const getUnEnrollFormPayload = (emailFormFieldValue: string | string[], promoId: string, urlToken: string) => {
  return {
    email: emailFormFieldValue,
    token: urlToken,
    promoId: promoId,
  };
};

export const extractKeyValueFromObject = (obj) => {
  let transformedObj = {};
  transformedObj[obj.key] = obj.value;
  return transformedObj;
};

export const getHCaptchaPayload = (formData: FormInfoData) => {
  if (!formData?.detail?.hcaptcha) {
    return { key: 'captcha', value: isSkipCaptcha };
  } else {
    return { key: 'hcaptcha', value: formData?.detail?.hcaptcha };
  }
};

// START GENAI@CHATGPT4
export const getSentosalCancelPayload = (formData: FormInfoData) => {
  const rawData = formData?.detail || {};
  const rawDataPayload = Object.keys(rawData)
    .filter(key => rawData[key]?.value?.length > 0 && key !== toExcludeAttribute)
    .map(key => ({ key: key, value: parseDateValue(rawData[key].value) }));

  // @ts-ignore
  const promoUrl = !!window?.mepaConfig? window?.mepaConfig?.promoUrl : ''
  return [getHCaptchaPayload(formData), ...rawDataPayload].reduce((payload, item) => {
    payload[item.key] = item.value;
    return payload;}, { promoUrl });
};
// END GENAI@CHATGPT4

// START GENAI@CHATGPT4
export const getFormPayload = (formData: FormInfoData, promoId: string,
                               vsfuScanId: string = null, vcesCardNumber: string = null,
                               redemptionToken: string = null) => {
  const rawData = formData?.detail || {};

  const additionalPayloads = [
    ...(vcesCardNumber ? [{ key: 'uniqueId', value: vcesCardNumber }] : []),
    ...(vsfuScanId ? [{ key: 'vsfuId', value: vsfuScanId }] : []),
  ];

  const rawDataPayload = Object.keys(rawData)
    .filter(key => rawData[key]?.value?.length > 0 && key !== toExcludeAttribute)
    .map(key => ({ key: key, value: parseDateValue(rawData[key].value) }));

  const formPayLoad = [getHCaptchaPayload(formData), ...additionalPayloads, ...rawDataPayload];

  if (redemptionToken) {
    return {
      promoId: promoId,
      submissionId: redemptionToken,
      form: formPayLoad
    };
  } else {
    return {
      promoId: promoId,
      form: formPayLoad
    };
  }
};
// END GENAI@CHATGPT4

export const getFormFieldErrors = (formData: FormInfoData) => {
  const rawData = formData?.detail || {};
  const errors: FormError[] = [];
  const VOP_LAST_FOUR = 'VOP_LAST_FOUR';
  const PAN = 'pan';
  const cardPart1Id = 'cardPart_1';
  Object?.keys(rawData)?.forEach(key => {
    let keyId = key;
    if (!rawData[key]?.isValid && rawData[key]?.error) {
      if (key === VOP_LAST_FOUR) {
        keyId = `${VOP_LAST_FOUR}${cardPart1Id}`;
      } else if (key === PAN) {
        keyId = `${PAN}${cardPart1Id}`;
      }
      errors.push({
        formIndex: keyId,
        message: rawData[key]?.error,
      });
    }
  });
  return errors;
};

// START GENAI@CHATGPT4
export async function getFormToken(baseUrl: string, promoId: string, xDataCenter: string, getHeader: Function) {
  const loginUrl: string = baseUrl + loginEndPoint;
  const loginBody = {
    'promoId': promoId,
  };
  return fetchApi(loginUrl, getHeader(xDataCenter, loginBody));
}


export async function fetchApi(url: string, header: any) {
  try {
    const response: globalThis.Response = await fetch(url, header);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export const disableSubmitButton = (disableState: boolean) => {
  /* START GENAI@GHCOPILOT */
  const submitButton = document.getElementById('submitBtn') as HTMLButtonElement;
  if (submitButton) {
    submitButton.disabled = disableState;
  }
  /* END GENAI@GHCOPILOT */
}

// END GENAI@CHATGPT4
